module.exports = __webpack_public_path__ + "static/media/events-error.a8afd386.png";